import { environment } from 'src/environments/environment.dev3';

const fbUrl = environment.BaseUrl + 'facebook/';
export const updateAccessToken = fbUrl + 'update-access-token';
export const validateAccessToken = fbUrl + 'validate-access-token';
export const getAccounts = fbUrl + 'ad-accounts';
export const getCampaign = fbUrl + '/ad-account/{accountId}/campaigns';
export const adSets = fbUrl + '/campaign/{campaignId}/adsets';
export const fbDisconnect = fbUrl + 'disconnect';
